/** Logged-in user fields from Redux `user` slice. */
export interface UserDisplayLabelSource {
	firstName?: string;
	lastName?: string;
	role?: string;
	roles?: string[];
}

export function normalizeRoleLabel(value: string): string {
	return value
		.replace(/_/g, " ")
		.replace(/\s*&\s*/g, " & ")
		.split(" ")
		.filter(Boolean)
		.map(part => {
			const upper = part.toUpperCase();
			if (["RDAT", "SD", "ED", "DG", "PSDA", "TEVTA", "PVTC"].includes(upper)) return upper;
			return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
		})
		.join(" ");
}

/** Active user label — name first, then role(s), matching dashboard welcome subtitle. */
export function getUserDisplayLabel(
	user: UserDisplayLabelSource | null | undefined,
	fallback = "Admin Portal",
): string {
	const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim();
	if (displayName) return displayName;

	const role = user?.role?.trim();
	if (role) return normalizeRoleLabel(role);
	if (user?.roles?.length) return user.roles.map(normalizeRoleLabel).join(", ");
	return fallback;
}
